import clsx from 'clsx';
import React, { useMemo } from 'react';
import { defaultGrid } from '@/config/univerjs';
import { calcTotalWidth, calcTotalHeight } from '../utils';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MIN_ROWS = 1000;
const MIN_COLS = 20;

const SpreadsheetSelections = _ref => {
  let {
    items,
    activeSheet = [],
    worksheetGrid = {},
    offsetX = 0,
    offsetY = 0,
    onClick
  } = _ref;
  const placeholderWidth = useMemo(() => {
    const firstRow = activeSheet[0] || [];
    return Math.round(calcTotalWidth(0, Math.max(MIN_COLS, firstRow.length), Infinity, worksheetGrid.columnData) * 2);
  }, [activeSheet, worksheetGrid]);
  const placeHolderHeight = useMemo(() => {
    return Math.round(calcTotalHeight(0, Math.max(MIN_ROWS, activeSheet.length), Infinity, worksheetGrid.rowData) * 2);
  }, [activeSheet, worksheetGrid]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    style: {
      top: `${defaultGrid.topHeaderHeight}px`,
      bottom: `${defaultGrid.bottomFooterHeight}px`,
      left: `${defaultGrid.leftHeaderWidth}px`
    },
    children: [/*#__PURE__*/_jsx("style", {
      type: "text/css",
      children: `.${styles.spreadsheetPlaceholder} { width: ${placeholderWidth}px; height: ${placeHolderHeight}px; }`
    }), /*#__PURE__*/_jsx("div", {
      className: styles.spreadsheetPlaceholder,
      style: {
        transform: `translate(${offsetX}px,${offsetY}px)`
      },
      children: items.map((selection, idx) => /*#__PURE__*/_jsx("div", {
        tabIndex: -1,
        "data-spreadsheet-selection-index": idx,
        style: {
          width: `${selection.width}px`,
          height: `${selection.height}px`,
          top: `${selection.top}px`,
          left: `${selection.left}px`,
          borderColor: `${selection.borderColor}`,
          background: !selection.active ? `${selection.background}` : ''
        },
        className: clsx(styles.selection, selection.active ? styles['selection--active'] : ''),
        onClick: () => onClick(selection.cellRefs, selection.details),
        onMouseDown: evt => {
          evt.stopPropagation();
        }
      }, `selections-${idx}-${selection.cellRefs}`))
    })]
  });
};

export default SpreadsheetSelections;